import React, { useState } from 'react';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark, FormFieldButton, FormGroupIcon } from './BaseInput';
import { colorAdditional, colorFieldsBorder } from '../../theme/palette';

const Password = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  required = false,
  error,
  showKeyIcon = false,
  input,
  meta,
  ...props
}) => {
  const [passwordShown, setPasswordShown] = useState(false); // Usar input.value e input.onChange se disponível (React Final Form)

  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name;
  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <PasswordFieldContainer>
        {showKeyIcon && <PasswordIcon>
            <KeyVariantIcon />
          </PasswordIcon>}
        <StyledPasswordInput name={fieldName} type={passwordShown ? 'text' : 'password'} value={fieldValue || ''} onChange={fieldOnChange} placeholder={placeholder} disabled={disabled} {...props} />
        <FormFieldButton active={passwordShown} type="button" onClick={() => setPasswordShown(shown => !shown)}>
          <EyeIcon />
        </FormFieldButton>
      </PasswordFieldContainer>
      {(error || meta && meta.touched && meta.error) && <ErrorMessage>
          {error || meta.error}
        </ErrorMessage>}
    </FormGroup>;
};

Password.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  showKeyIcon: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object
}; // Exportar PasswordIcon para manter compatibilidade

export const PasswordIcon = styled.div`
  padding: 6px;
  height: 32px;
  background: ${colorFieldsBorder};
  border: 1px solid ${colorFieldsBorder};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${colorAdditional};
    width: 18px;
    height: 18px;
    transition: all 0.3s;
  }
`;
export default Password; // region STYLES

const PasswordFieldContainer = styled.div`
  display: flex;
  width: 100%;
`;
const StyledPasswordInput = styled.input`
  flex: 1;
  padding: 5px 10px;
  font-size: 12px;
  height: 32px;
  transition: border 0.3s;
  background: transparent;
  border: 1px solid ${colorFieldsBorder};
  color: #646777;
  
  &::-webkit-input-placeholder {
    color: ${colorAdditional};
  }
  &::-moz-placeholder {
    color: ${colorAdditional};
  }
  &:-moz-placeholder {
    color: ${colorAdditional};
  }
  &:-ms-input-placeholder {
    color: ${colorAdditional};
  }
  
  &[disabled] {
    background: #f2f4f7;

    &:focus, &:active {
      border-color: #eff1f5;
    }
  }

  &:focus, &:active {
    outline: none;
    border-color: #4ce1b6;
  }
`; // endregion